<ng-container *ngFor="let item of _listItems; let i=index">
    <div *ngIf='form && form.controls[item.id]' class="container" [formGroup]="form.controls[item.id]" [ngClass]="{
        'light-container': form.controls[item.id].controls['value'].value > 0
        }">
        <div class="fs-6 bold opacity" [ngClass]="{'hasValue': form.controls[item.id].controls['value'].value > 0}">
            {{_listItems[i].alias}}</div>
        <div class="opacity" [ngClass]="{'hasValue': form.controls[item.id].controls['value'].value > 0}">
            <div><input inputmode="numeric" pattern="[0-9]*" currencyFormatter [defaultValue]="true"
                    class="fs-6 bold hasValue" placeholder="0" formControlName="value" maxlength="6" /></div>
        </div>
    </div>
    <div>
        <ng-container *ngFor="let validation of validationsList;">
            <mat-error
                *ngIf="form && form.controls[item.id].controls['value'].hasError(validation.name) && form.controls[item.id].controls['id'].value == validation.id">
                {{validation.message}}</mat-error>
        </ng-container>


    </div>
</ng-container>